export default __webpack_public_path__ + "static/favicon-0e5c076b87bf41513b4a9877546ea9a0.ico";